import { URLParamBuilder } from '@/utils/functions';
import * as PATHS from '@/constants/path';
import { request } from '@/services/api/request';

export function fetchApiKeysRequest() {
  return request<any>(PATHS.FETCH_API_KEYS, {
    method: 'GET',
  });
}

export function fetchApiKeyScopesRequest() {
  return request<any>(PATHS.FETCH_API_KEY_SCOPES, {
    method: 'GET',
  });
}

export function getApiKeyRequest({ params }) {
  const url = URLParamBuilder(PATHS.GET_API_KEY, { params });
  return request<any>(url, {
    method: 'GET',
  });
}

export function createApiKeyRequest({ payload }) {
  return request<any>(PATHS.CREATE_API_KEY, {
    method: 'POST',
    data: payload,
  });
}

export function updateApiKeyRequest({ params, payload }) {
  const url = URLParamBuilder(PATHS.UPDATE_API_KEY, { params });
  return request<any>(url, {
    method: 'PUT',
    data: payload,
  });
}

export function patchApiKeyRequest({ params, payload }) {
  const url = URLParamBuilder(PATHS.PATCH_API_KEY, { params });
  return request<any>(url, {
    method: 'PATCH',
    data: payload,
  });
}

export function deleteApiKeyRequest({ params }) {
  const url = URLParamBuilder(PATHS.DELETE_API_KEY, { params });
  return request<any>(url, {
    method: 'DELETE',
  });
}

export function regenerateApiKeyRequest({ params }) {
  const url = URLParamBuilder(PATHS.REGENERATE_API_KEY, { params });
  return request<any>(url, {
    method: 'POST',
  });
}
